import React,{useState,useEffect,useRef}from 'react'
import { UploadOutlined,} from '@ant-design/icons';
import { Button,Modal,message,Form,Input,Upload, Select,} from 'antd';
import { useSystemUpdateQuery, useUpdateSaveSystemMutation } from '../store/ReactWebSiteApi';
import MyEditor from '../cpn/MyEditor';
import {appType} from './appType'
import { appPayType } from './appType';
function AppEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({esv_remark:'',esv_content:''});
    //官网广告图
    const [defaultSite,setDefaultSite] = useState();
    const homePicEdit = (e) => {
        if (e.file.status === 'done'||e.file.status==='removed') {
            const fileArr = e.fileList.map((item) => {
                const { response } = item
                return response.Result
            })
            console.log(e);
            let fileStr = fileArr + "";  
            if(fileStr === null){
                fileStr = ''
            }
            setInfo(prevState=>({...prevState,esv_image_name:fileStr}))
        }
    }
    //产品图标
    const [defaultApp,setDefaultApp] = useState();
    const listPicEdit = (e,f) => {
        console.log(e,f);
        if (e.file.status === 'done'||e.file.status==='removed') {
            const fileArr = e.fileList.map((item) => {
                const { response } = item
                return response.Result
            })
            let fileStr = fileArr + "";  
            if(fileStr === null){
                fileStr = ''
            }
            setInfo(prevState=>({...prevState,esv_image2_name:fileStr}))
        }
        
    }
    const editForm = useRef()
    const {data:dataEdit,isSuccess:isSuccessEdit} = useSystemUpdateQuery({esv_id:props.esv_id},{skip:!open})
    useEffect(() => {
        if(isSuccessEdit){
            if(dataEdit.Status==='success'){
                // console.log(dataEdit);
                //官网广告图
                if (dataEdit.Result.esv_image_name) {
                    let options = [];
                    let a = {};
                    a.uid = 1;
                    a.url = `/api/assets/images/application/${dataEdit.Result.esv_image_name}`
                    a.response = {Result:dataEdit.Result.esv_image_name}
                    options.push(a);
                    //console.log(options);
                    setDefaultSite(<Upload
                        name="image_file"
                        action="/api/ReactApi/zd_single_upload_image"
                        listType="picture"
                        defaultFileList={options}
                        className="upload-list-inline"
                        onChange={homePicEdit}
                        maxCount={1}
                        >
                        <Button icon={<UploadOutlined />}>点击上传</Button>
                    </Upload>)
                }else{
                    setDefaultSite(<Upload
                        name="image_file"
                        action="/api/ReactApi/zd_single_upload_image"
                        listType="picture"
                        className="upload-list-inline"
                        onChange={homePicEdit}
                        maxCount={1}
                        >
                        <Button icon={<UploadOutlined />}>点击上传</Button>
                    </Upload>)
                }
                //产品图标
                if (dataEdit.Result.esv_image2_name) {
                    let options = [];
                    let a = {};
                    a.uid = 1;
                    a.url = `/api/assets/images/application/${dataEdit.Result.esv_image2_name}`
                    a.response = {Result:dataEdit.Result.esv_image2_name}
                    options.push(a);
                    //console.log(options);
                    setDefaultApp(options)
                }else{
                    setDefaultApp([])
                }
                editForm.current.setFieldsValue({
                    esv_name:dataEdit.Result.esv_name,
                    esv_content:dataEdit.Result.esv_content,
                    esv_remark:dataEdit.Result.esv_remark,
                    esv_router:dataEdit.Result.esv_router,
                    esv_type_id:[dataEdit.Result.esv_type_id],
                    esv_cost_type:[dataEdit.Result.esv_cost_type],

                })
                setInfo(prevState=>({...prevState,
                    esv_naesv_type_idme:dataEdit.Result.esv_type_id,
                    esv_name:dataEdit.Result.esv_name,
                    esv_content:dataEdit.Result.esv_content,                  
                    esv_remark:dataEdit.Result.esv_remark,                  
                    esv_type_id:dataEdit.Result.esv_type_id,                  
                    esv_image_name:dataEdit.Result.esv_image_name,                  
                    esv_image2_name:dataEdit.Result.esv_image2_name,                  
                    esv_router:dataEdit.Result.esv_router,                    
                    esv_cost_type:dataEdit.Result.esv_cost_type,                    
                }))
            }
        }
    },[dataEdit,isSuccessEdit])
    const [goodsEdit] = useUpdateSaveSystemMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改产品'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        esv_name:info.esv_name,
                        esv_image_name:info.esv_image_name,
                        esv_image2_name:info.esv_image2_name,
                        esv_type_id:info.esv_type_id,                                    
                        esv_uid:localStorage.getItem('eu_id'),
                        esv_uname:localStorage.getItem('eu_name'),
                        esv_content:info.esv_content,
                        esv_router:info.esv_router,
                        esv_remark:info.esv_remark,
                        esv_id:props.esv_id,        
                        esv_cost_type:info.esv_cost_type                           
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >
                    <Form.Item name="esv_type_id" label='品牌平台' wrapperCol={{span:10}} required>
                        <Select options={appType} onChange={(e) => {setInfo(prevState=>({...prevState,esv_type_id:e}))}}/>
                    </Form.Item>
                    <Form.Item name="esv_name" label='产品名称' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,esv_name:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="esv_cost_type" label='收费类型' wrapperCol={{span:10}} required>
                        <Select options={appPayType} onChange={(e) => {setInfo(prevState=>({...prevState,esv_cost_type:e}))}}/>
                    </Form.Item>
                    <Form.Item label="官网广告图" 
                        required
                        rules={[{
                            required:true,
                        }]}
                        valuePropName='fileList'
                        getValueFromEvent={e => {
                            if (Array.isArray(e)) {
                                return e;
                            }
                            return e && e.fileList;
                        }}
                        >
                        {defaultSite}
                    </Form.Item>
                    <Form.Item label="产品图标" 
                        required
                        rules={[{
                            required:true,
                        }]}
                        valuePropName='fileList'
                        getValueFromEvent={e => {
                            if (Array.isArray(e)) {
                                return e;
                            }
                            return e && e.fileList;
                        }}
                        >
                        <Upload
                            name="image_file"
                            action="/api/ReactApi/zd_single_upload_image"
                            listType="picture"
                            className="upload-list-inline"
                            onChange={listPicEdit}
                            fileList={defaultApp}
                            onRemove={(e) => {setDefaultApp(e.fileList)}}
                        >
                            <Button icon={<UploadOutlined />}>点击上传</Button>
                        </Upload>
                    </Form.Item>
                    <Form.Item name="esv_remark" label='用户需求' wrapperCol={{span:20}}required>
                        <MyEditor onChange={(e) => {setInfo(prevState=>({...prevState,esv_remark:e}))}}  value={info.esv_content}/>
                    </Form.Item>
                    <Form.Item name="esv_content" label='收费模式' wrapperCol={{span:20}} >
                        <MyEditor onChange={(e) => {setInfo(prevState=>({...prevState,esv_content:e}))}} value={info.esv_remark}/>
                    </Form.Item>
                    <Form.Item name="esv_router" label='路由' wrapperCol={{span:15}}>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,esv_router:e.target.value}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default AppEdit